import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import classNames from "classnames";

import config from "../shards-pro/config.json";

class Pagination extends Component {
  render() {
    const { catIdx } = this.props;
    const prev = catIdx - 1;
    const next = catIdx + 1;

    let prevLink, nextLink;

    if (typeof config.categories[prev] !== "undefined") {
      prevLink = (
        <Link
          className={classNames("prev", "link")}
          to={`/${config.categories[prev].path}`}
        >
          &larr; {config.categories[prev].title}
        </Link>
      );
    }

    if (typeof config.categories[next] !== "undefined") {
      nextLink = (
        <Link
          className={classNames("next", "link")}
          to={`/${config.categories[next].path}`}
        >
          {config.categories[next].title} &rarr;
        </Link>
      );
    }

    return (
      <PaginationWrapper className="d-none d-sm-block">
        {prevLink}
        <p className="current-section-title">{config.categories[catIdx].titleLong}</p>
        {nextLink}
      </PaginationWrapper>
    );
  }
}

export default Pagination;

const PaginationWrapper = styled.div`
  display: flex;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  background: #fff;
  will-change: transform, box-shadow;
  transition: transform 250ms ease, box-shadow 250ms ease;
  box-shadow: 0 10px 60px rgba(0, 0, 0, 0.05), 0 3px 10px rgba(0, 0, 0, 0.1);

  .hidden {
    transform: translateY(100%);
    box-shadow: none;
  }

  .link {
    display: block;
    text-decoration: none;
    color: #000;
    transition: all 250ms ease-in-out;

    &:hover {
      background: #2d53fe;
      color: #fff;
      border-color: #2d53fe !important;
    }
  }

  .link,
  .current-section-title {
    padding: 10px 20px;
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 2px;
    font-size: 10px;

  }

  .link.next {
    float: right;
    border-left: 1px solid #ddd;
    margin-left: auto;
  }

  .link.prev {
    float: left;
    border-right: 1px solid #ddd;
    margin-right: auto;
  }

  .current-section-title {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
  }
`;
